<template>
  <div>
    <portlet
      :icon="'fas fa-users portlet-icon'"
      :title="$t('engagement.employeeprofile')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20"
    >
      <template slot="actionsBlock">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <i class="fas fa-long-arrow-left mr-2"></i> Back
        </button>
      </template>

      <template slot="portletBody">
        <div class="container-fluid">
          <div class="row">
            <profileInfo
              v-if="dataloaded == true"
              :user="user"
              :uwesBtn="uwesBtn"
              :evaluation="evaluation"
            />
            <profileMilestones :user="user" />
            <profileStats :user="user" />
          </div>
        </div>
      </template>
    </portlet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import profileInfo from "@/components/engagement/profilePage/ProfileInfo.vue";
import profileMilestones from "@/components/engagement/profilePage/ProfileMilestones.vue";
import profileStats from "@/components/engagement/profilePage/ProfileStatistics.vue";

export default {
  name: "EngagamentProfile",
  mixins: [],
  components: {
    profileInfo,
    profileMilestones,
    profileStats,
  },
  data() {
    return {
      dataloaded: false,
      user: {},
      uwesBtn: false,
      searchUid: "",
      searchActivity: "",
      evaluation: {},
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("userData", ["getMyDepartments"]),
    ...mapGetters("users", ["getMe", "getClaims", "getUser"]),
    ...mapGetters("uwes", ["getUwes"]),
    ...mapGetters("evaluation", ["getEvaluation", "getToEvaluate"]),
  },
  mounted() {},
  methods: {
    async getUwesData() {
      const where = [
        ["userId", "==", this.$route.params.userId],
        ["companyId", "==", this.getClaims.companyId],
      ];
      const orderBy = ["created_at", "desc"];
      await this.$store
        .dispatch("uwes/fetchAndAdd", { clauses: { where, orderBy, limit: 1 } })
        .catch((e) => {});

      // uwes voor user inladen en berekenen
      const uwesData = await this.getUwes(this.$route.params.userId);
      if(uwesData === undefined && this.$route.params.userId === this.getMe.id){
        this.uwesBtn = true
      }
      else if (uwesData && this.$route.params.userId === this.getMe.id) {
        const timeDif =
          Math.floor(Date.now() / 1000) - uwesData.created_at.seconds;
        if (timeDif > 5259487) {
          this.uwesBtn = true;
        }
       else {
        this.uwesBtn = false;
      }}
    },

    async getEvaluationData() {
      const where = [
        // ["evaluateeId", "==", this.$route.params.userId],
        ["companyId", "==", this.getClaims.companyId],
      ];
      const orderBy = ["created_at", "desc"];
      await this.$store
        .dispatch("evaluation/fetchAndAdd", {
          clauses: { where, orderBy, limit: 1 },
        })
        .catch((e) => {});

      // uwes voor user inladen en berekenen
      const evaluationData = await this.getToEvaluate(
        this.$route.params.userId
      );
      if (evaluationData) {
        this.dataloaded = true;
        if (evaluationData.answers.length === 3) {
          console.log(evaluationData);
        } else {
          this.evaluation = evaluationData
        }
      } else {
        this.dataloaded = true;
      }
    },
  },
  async created() {
    this.$store.commit("setLoading", true);
    await this.$FUNCTIONS
      .Users("getUserById", this.$route.params.userId)
      .then((res) => {
        this.user = res.data;
        this.$store.commit("setLoading", false);
      })
      .catch((e) => {
        this.$store.commit("setLoading", false);
      });

    this.getUwesData();
    this.getEvaluationData();

    // uwes voor user inladen en berekenen
    // const evaluationData = await this.getEvaluations(this.$route.params.userId);
    // if (evaluationData) {
    //   console.log(evaluationData)
    // } else {
    //   alert('nope')
    // }
  },
};
</script>

<style scoped lang="scss">
// @import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>
